export default __webpack_public_path__ + "static/media/close.5d8dcf91.svg";